import { defineComponent as E, mergeModels as P, useModel as R, useSlots as w, computed as k, useTemplateRef as D, createElementBlock as i, openBlock as s, Fragment as T, createVNode as v, createBlock as r, unref as a, withCtx as b, createElementVNode as C, normalizeClass as u, createCommentVNode as m, renderSlot as n, resolveDynamicComponent as H, mergeProps as N } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/MenuToggle/menu-toggle.js";
import { CaretDownIcon as V } from "../../packages/icons/dist/esm/icons/caret-down-icon.js";
import { CircleCheckIcon as W } from "../../packages/icons/dist/esm/icons/circle-check-icon.js";
import { CircleExclamationIcon as A } from "../../packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import { TriangleExclamationIcon as z } from "../../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { useOUIAProps as F } from "../../helpers/ouia.js";
import { createReusableTemplate as O } from "@vueuse/core";
const U = ["disabled", "aria-expanded"], Y = /* @__PURE__ */ E({
  name: "PfMenuToggle",
  inheritAttrs: !1,
  __name: "MenuToggle",
  props: /* @__PURE__ */ P({
    disabled: { type: Boolean },
    fullHeight: { type: Boolean },
    fullWidth: { type: Boolean },
    placeholder: { type: Boolean },
    variant: {},
    status: {},
    small: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: ["update:expanded"],
  setup(g, { expose: $ }) {
    const f = g, d = R(g, "expanded"), h = w(), t = k(() => f.variant === "typeahead"), o = k(() => !t.value && !!h["split-buttons"]), B = F({ id: f.ouiaId, safe: f.ouiaSafe }), y = D("elRef"), [I, c] = O();
    function M() {
      var e;
      (e = y.value) == null || e.focus();
    }
    return $({
      el: y,
      focus: M
    }), (e, p) => (s(), i(T, null, [
      v(a(I), null, {
        default: b(() => [
          C("span", {
            class: u(a(l).menuToggleControls)
          }, [
            e.status || e.$slots["status-icon"] ? (s(), i("span", {
              key: 0,
              class: u(a(l).menuToggleStatusIcon)
            }, [
              n(e.$slots, "status-icon", {}, () => [
                e.status === "success" ? (s(), r(a(W), { key: 0 })) : e.status === "warning" ? (s(), r(a(z), { key: 1 })) : e.status === "danger" ? (s(), r(a(A), { key: 2 })) : m("", !0)
              ])
            ], 2)) : m("", !0),
            C("span", {
              class: u(a(l).menuToggleToggleIcon)
            }, [
              v(a(V))
            ], 2)
          ], 2)
        ]),
        _: 3
      }),
      (s(), r(H(t.value || o.value ? "div" : "button"), N({ ...a(B), ...e.$attrs }, {
        ref: "elRef",
        class: [a(l).menuToggle, {
          [a(l).modifiers.typeahead]: t.value,
          [a(l).modifiers.splitButton]: o.value,
          [a(l).modifiers.expanded]: d.value,
          [a(l).modifiers.primary]: e.variant === "primary",
          [a(l).modifiers.secondary]: e.variant === "secondary",
          [a(l).modifiers[e.status]]: e.status,
          [a(l).modifiers.plain]: e.variant === "plain" || e.variant === "plainText",
          [a(l).modifiers.text]: e.variant === "plainText",
          [a(l).modifiers.fullHeight]: e.fullHeight,
          [a(l).modifiers.fullWidth]: e.fullWidth,
          [a(l).modifiers.disabled]: e.disabled,
          [a(l).modifiers.placeholder]: e.placeholder,
          [a(l).modifiers.small]: e.small
        }],
        type: t.value || o.value ? void 0 : "button",
        "aria-expanded": t.value || o.value ? void 0 : d.value,
        disabled: t.value || o.value ? void 0 : e.disabled,
        onClick: p[1] || (p[1] = (S) => t.value || o.value ? void 0 : d.value = !d.value)
      }), {
        default: b(() => [
          !o.value && e.variant === "plain" ? n(e.$slots, "default", { key: 0 }) : (s(), i(T, { key: 1 }, [
            !o.value && e.$slots.icon ? (s(), i("span", {
              key: 0,
              class: u(a(l).menuToggleIcon)
            }, [
              n(e.$slots, "icon")
            ], 2)) : m("", !0),
            !o.value && !t.value ? (s(), i("span", {
              key: 1,
              class: u(a(l).menuToggleText)
            }, [
              n(e.$slots, "default")
            ], 2)) : o.value ? n(e.$slots, "split-buttons", { key: 3 }) : n(e.$slots, "default", { key: 2 }),
            !o.value && e.$slots.badge ? (s(), i("span", {
              key: 4,
              class: u(a(l).menuToggleCount)
            }, [
              n(e.$slots, "badge")
            ], 2)) : m("", !0),
            t.value || o.value ? (s(), i("button", {
              key: 5,
              type: "button",
              class: u(a(l).menuToggleButton),
              disabled: e.disabled,
              "aria-expanded": d.value,
              "aria-label": "Menu toggle",
              onClick: p[0] || (p[0] = (S) => d.value = !d.value)
            }, [
              o.value ? (s(), i("span", {
                key: 0,
                class: u(a(l).menuToggleText)
              }, [
                n(e.$slots, "default")
              ], 2)) : n(e.$slots, "default", { key: 1 }),
              v(a(c))
            ], 10, U)) : (s(), r(a(c), { key: 6 }))
          ], 64))
        ]),
        _: 3
      }, 16, ["class", "type", "aria-expanded", "disabled"]))
    ], 64));
  }
});
export {
  Y as default
};
